export default __webpack_public_path__ + "static/media/co4.7fe49ccd.jpeg";